import { Component, OnInit } from '@angular/core';
import { AngularTokenService } from 'angular-token';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray, NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LoaderService } from '../../utils/loader.service';
import Swal from 'sweetalert2';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  accountConfirm: any;
  public inputType: any = 'Password';


  constructor(
    private tokenService: AngularTokenService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private loaderService: LoaderService,
    public router: Router,
    public route: ActivatedRoute,
    private authservice: AuthService

  ) { }

  ngOnInit() {
    this.loginForm = new FormGroup({
      'login': new FormControl("", Validators.required),
      'password': new FormControl("", Validators.required)
    });

    this.route.queryParams.subscribe(params => {
      let message;
      this.accountConfirm = params['account_confirmation_success'];
      message = params['message'];
      if (this.accountConfirm) {
        this.toastr.success("Confirmed Account Successfully. Please Login.", 'Success');
      } else if (message) {
        this.toastr.success('Your account has been activated already, please try signing in', 'Success');
      }
    });

  }


  toggleInputType(type) {
    if (type == 'Password') {
      this.inputType = 'text';
    }
    else {
      this.inputType = 'Password';
    }
  }


  onSubmit(form) {
    this.loaderService.display(true);
    this.tokenService.signIn({
      login: form.value.login,
      password: form.value.password
    }).subscribe(
      res => {
        // console.log(res);   
        localStorage.setItem('id', res['body']['data']['id']);
        localStorage.setItem('email', res['body']['data']['email']);
        localStorage.setItem('account_type_id', res['body']['data']['account_type_id']);
        localStorage.setItem('has_onboarded', res['body']['data']['has_vendor_onboarded']);
        localStorage.setItem('role_name', res['body']['data']['role']['name']);
        localStorage.setItem('is_approved', res['body']['data']['is_vendor_approved']);
        localStorage.setItem('name', res['body']['data']['name']);
        localStorage.setItem('avatar', res['body']['data']['user_avatar']['url']);
        localStorage.setItem('isRMS', res['data']['isRMS']);
        if (localStorage.getItem('is_approved') == "true") {
          this.router.navigate(['/admin/dashboard']);
        }
        else if (localStorage.getItem('has_onboarded') == "false") {
          this.router.navigate(['/onboarding']);
        }
        else {
          this.router.navigate(['/onboarding/submitted']);
        }
        this.loaderService.display(false);
        this.toastr.success("Logged in successfully.", 'Success');

        this.authservice.getEngageToken(res['body']['data']['id']).subscribe(
          (res: any) => {
            console.log(res)
            localStorage.setItem('engage_auth_code', res.engage_auth_code)
          },
          err => {
            console.log(err)
          }
        );
      }, err => {
        this.loaderService.display(false);
        if (err.error.message) {
          let msg = err.error.message;
          if (err.error.message == 'This email is not registered.', 'Error') {
            this.toastr.error(msg, 'Error');
          } else {
            this.toastr.error(msg, 'Error');
          }
        } else {
          for (let i in err.error.errors) {
            this.toastr.error(err.error.errors[i]);
          }
        }
      }
    );
  }

}
